import Vue from 'vue';
import VueResource from 'vue-resource';
import { API_ROOT } from '../config';

Vue.use(VueResource);

// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';
// Vue.http.headers.common['Access-Control-Allow-Headers'] = '*';
// Vue.http.options.crossOrigin = true;
// Vue.http.options.credentials = true;

Vue.http.options.emulateJSON = true;

export const TextResource = Vue.resource(`${API_ROOT}lasertext/?l={lang}`);
export const LanguageListResource = Vue.resource(`${API_ROOT}languagelist`);
export const ApplicationResource = Vue.resource(`${API_ROOT}applications/?l={lang}&t={type}`);
export const LaserResultResource = Vue.resource(`${API_ROOT}laserresult`);
export const ResultEmailResource = Vue.resource(`${API_ROOT}resultemail`);



// WEBPACK FOOTER //
// ./src/api/resources.js